import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex min-h-full flex-col justify-center pt-4 pb-8 mx-3 mt-10 sm:px-6 lg:px-8"
}
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "text-center text-2xl sm:text-3xl font-bold leading-9 tracking-tight text-dark-blue" }
const _hoisted_4 = { class: "text-center text-dark-blue text-sm mt-2" }
const _hoisted_5 = { class: "sm:mx-auto sm:w-full" }
const _hoisted_6 = { class: "px-4 py-8 sm:px-12" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/campaign_created_success.svg",
  alt: "Success Image"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "mt-6 sm:max-w-2xl mx-auto" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/landing",
    class: "py-2.5 px-28 rounded-lg shadow-lg bg-light-blue text-white"
  }, "Continue")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showPopup)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.popupTitle), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.popupShortMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.showSuccessImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", {
                class: "text-sm sm:text-base text-dark-blue text-center",
                innerHTML: _ctx.popupLongMessage
              }, null, 8, _hoisted_11)
            ]),
            _hoisted_12
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}